import { render, staticRenderFns } from "./PosTransactionsFilterForm.vue?vue&type=template&id=7650b074&"
import script from "./PosTransactionsFilterForm.vue?vue&type=script&lang=js&"
export * from "./PosTransactionsFilterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports